export const REBATES_SUBMISSIONS_ROUTE = {
    title: 'Rebates',
    name: 'store-management-rebates',
};
export const REBATES_VOUCHERS_ROUTE = {
    title: 'Vouchers',
    name: 'store-management-vouchers',
};
export const REBATES_REDEEMED_VOUCHERS_ROUTE = {
    title: 'Vouchers',
    name: 'store-manager-vouchers',
};
export const REBATES_VOUCHERS_REDEMPTION_ROUTE = {
    title: 'Voucher Redemption',
    name: 'store-manager-vouchers-redemption',
};
